export enum ShipmentEtaStatus {
    Unknown = 0,
    OnTime,
    Late,
    Early
}